import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Container } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import BackAndNextButtons from '../components/BackAndNextButtons';
import { useData } from '../Form';
import { useStep } from '../Form';
import { useConferenceConfig } from '../components/ConferenceConfigContext';
import { useState } from 'react';

// The venue's own waiver (e.g. a SmartWaiver iframe), only relevant for
// conferences held somewhere that requires one - see conferences/{id}
// .campWaiverUrl/.campWaiverName in the admin Conference Settings panel.
// Separate from WaiverForm, which is the church's own release of liability
// and applies to every conference.
export default function CampWaiverForm() {

  const { data, updateData } = useData();
  const { incrementStep } = useStep();
  const { config } = useConferenceConfig();

  const [values, setValues] = useState({
    signedWaiverCamp: data.signedWaiverCamp ?? false,
  });

  const [error, setError] = useState({
    signedWaiverCamp: false,
  });

  function checkForErrors() {
    let newError = {
      signedWaiverCamp: !values.signedWaiverCamp,
    }
    setError(newError);
    return Object.keys(newError).some((k) => newError[k]);
  }

  function handleNext() {
    if (checkForErrors()) {
      // If there are errors, don't proceed
      return;
    } else {
      incrementStep(); // Proceed to the next step
      updateData(values); // Save the current form data
    }
  }

  const campName = config.campWaiverName || 'the camp';

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        {config.campWaiverName ? `${config.campWaiverName} Waiver` : 'Camp Waiver'}
      </Typography>
      {config.campWaiverUrl ? (
        <Container
          maxWidth={false}
          sx={{
            height: '100vh',
            padding: 0,
          }}
        >
          <iframe
            src={config.campWaiverUrl}
            width="100%"
            height="100%"
            title="Camp Waiver"
            style={{ border: 'none' }}
          ></iframe>
        </Container>
      ) : (
        <Typography color="error">
          No camp waiver link is configured for this conference yet - set one under Conference Settings, or disable this step if one isn't needed.
        </Typography>
      )}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={values.signedWaiverCamp}
                onChange={() => setValues({ ...values, signedWaiverCamp: !values.signedWaiverCamp })}
              />
            }
            label={
              <Typography style={{ color: error.signedWaiverCamp ? 'red' : 'inherit' }}>
                By checking this box, I confirm that I have filled out {campName}'s waiver *
              </Typography>
            }
          />
        </Grid>
      </Grid>
      <BackAndNextButtons handleNext={handleNext}></BackAndNextButtons>

    </React.Fragment>
  );
}
